module.exports = __webpack_public_path__ + "static/img/2_2_2_1.b8643bf2.jpg";